module.exports = __webpack_public_path__ + "1657b579c28d653eea0df983c2cddaab.gif";


//////////////////
// WEBPACK FOOTER
// ../components/hai-2.gif
// module id = 496
// module chunks = 0